module.exports = __webpack_public_path__ + "images/7a4e4a8743d9874c616fe8f7af7cf917.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/carousel.png
// module id = 909
// module chunks = 0